import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SecurityPermissionName } from '@app/core/models/permission';
import { ProductOptionPageComponent } from '@business/product-option/components/product-option-page/product-option-page.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      {
        component: ProductOptionPageComponent,
        data: {
          allowedPermissions: [SecurityPermissionName.VIEW_PRODUCT_OPTION],
        },
        path: '',
        pathMatch: 'full',
      },
    ]),
  ],
})
export class ProductOptionRoutingModule {}
